import React, { useContext, useMemo, useState, useEffect } from "react";
import { useIntl } from "react-intl";
import "./MemberSelect.scss";

import { useSelector } from "react-redux";
import CustomSelect from "src/app/components/CustomSelect/CustomSelect";

import { translateMessage } from "src/app/methods/translateMessage";
import AvatarPlaceholder from "src/images/avatar-purple.svg";
import { Img } from "src/app/components/Img/Img";
import { DictionaryFiltersContext } from "../../DictionaryFilters";

export function MemberSelect({ col, sendFilter }) {
  const intl = useIntl();
  const {
    projectReducer: { activeMembersList },
  } = useSelector((state) => state);

  const { dictionaryFilters } = useContext(DictionaryFiltersContext);

  const { filters } = dictionaryFilters;

  const filterOption = (candidate, input) => {
    return (
      candidate.data.__isNew__ ||
      candidate.value.name.toUpperCase().includes(input.toUpperCase())
    );
  };

  const options = useMemo(
    () =>
      activeMembersList
        .filter(
          (member) =>
            !member?.hideOnMembersList && member?.status !== "removed",
        )
        .map((member) => ({
          value: { email: member.email, name: member.name, id: member.id },
          label: (
            <span className="activity-filters__option">
              <Img
                className="activity-filters__option-image"
                src={member?.avatarUrl}
                fallbackImageSrc={AvatarPlaceholder}
                alt="avatar"
              />
              <span className="activity-filters__option-text">
                {member.name}
              </span>
            </span>
          ),
        })) || [],
    [activeMembersList],
  );

  const [value, setValue] = useState([]);

  useEffect(() => {
    setValue(
      filters[col.uuid]?.value
        ?.map((v) => options.find((o) => o.value.id === v))
        .filter(Boolean) || [],
    );
  }, [filters, col.uuid, options]);

  return (
    <CustomSelect
      className="projects-table-filters__member-select ws-react-select ws-react-select--with-tiles"
      value={value}
      onChange={(nv) => {
        setValue(nv);
        sendFilter(
          col.uuid,
          nv.map((v) => v.value.id),
        );
      }}
      placeholder={translateMessage({
        intl,
        id: "ws_all",
        defaultMessage: "All",
      })}
      options={options}
      isMulti
      withTiles
      openMenuOnFocus={false}
      isSearchable
      filterOption={filterOption}
      data-qa={col.name}
    />
  );
}
